import ProviderDetail from "../../../components/cm/Dashboard/FullPages/ProviderDetail/index.jsx";
import AppWrapper from "../../../components/cm/AppWrapper.jsx";
import SideBarMain from "../../../components/cm/SideBarMain";

export default () => {
  return (
    <AppWrapper.WithSidebar sidebar={<SideBarMain />}>
      <ProviderDetail />
    </AppWrapper.WithSidebar>
  );
};
